"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var category_type_1 = require("../../item/type/category-type");
var measure_type_1 = require("../../item/type/measure-type");
var date_category_type_1 = require("../../item/type/date-category-type");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var filter_type_1 = require("./filter-type");
var filter_type_option_1 = require("./filter-type-option");
var combobox_options_1 = require("../../../combobox-options");
/**
 * Helper type to host multiple {@link FilterTypeOption}s, actually an array of {@link FilterTypeOption} items, yet
 * extends a more common structure to achieve optimal code reuse.
 */
var FilterTypeOptions = /** @class */ (function (_super) {
    __extends(FilterTypeOptions, _super);
    function FilterTypeOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Fetches filtering methods associated with specified input criteria, namely category type and in case of timeline
     * categories the subtype.
     * @param {!CategoryType} type - The type of category.
     * @param {DateCategoryType} [dateType=null] - The subtype of timeline category, irrelevant for other types.
     * @returns {FilterTypeOptions} Number of options matching our criteria.
     */
    FilterTypeOptions.ofCategory = function (type, dateType) {
        if (dateType === void 0) { dateType = null; }
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(type);
        if (type === category_type_1.CategoryType.DATE && FilterTypeOptions.CATEGORY_TIMELINE.has(dateType)) {
            return FilterTypeOptions.CATEGORY_TIMELINE.get(dateType);
        }
        else if (FilterTypeOptions.CATEGORY.has(type)) {
            return FilterTypeOptions.CATEGORY.get(type);
        }
        else {
            return [];
        }
    };
    /**
     * Fetches filtering methods associated with specified input criteria, namely measure type.
     * @param {MeasureType} type - The type of measure.
     * @returns {FilterTypeOptions} Number of options matching our criteria.
     */
    FilterTypeOptions.ofMeasure = function (type) {
        return FilterTypeOptions.MEASURE.has(type) ? FilterTypeOptions.MEASURE.get(type) : [];
    };
    /**
     * Fetches the default filtering method from all the possible methods associated with specified input criteria,
     * namely category type and in case of timeline categories the subtype.
     * @param {CategoryType} type - The type of category.
     * @param {DateCategoryType} [dateType=null] - The subtype of timeline category, irrelevant for other types.
     * @returns {FilterTypeOption} The default option from all possible ones.
     */
    FilterTypeOptions.defaultOfCategory = function (type, dateType) {
        if (dateType === void 0) { dateType = null; }
        return FilterTypeOptions.findDefaultFilterType(FilterTypeOptions.ofCategory(type, dateType));
    };
    /**
     * Fetches the default filtering method from all the possible methods associated with specified input criteria,
     * namely measure type.
     * @param {!MeasureType} type - The type of category.
     * @returns {FilterTypeOption} The default option from all possible ones.
     */
    FilterTypeOptions.defaultOfMeasure = function (type) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(type);
        return FilterTypeOptions.findDefaultFilterType(FilterTypeOptions.ofMeasure(type));
    };
    /**
     * Finds the default filtering method from all the methods passed as an argument.
     * @param {!FilterTypeOptions} options - Number of options to choose the default one from.
     * @returns {FilterTypeOption} The default option from all possible ones.
     */
    FilterTypeOptions.findDefaultFilterType = function (options) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(options);
        var defaultOption = options.find(function (option) {
            return option.isDefault === true;
        });
        return defaultOption ? defaultOption : null;
    };
    /**
     * Knowledge-like mapping of category to associated filtering methods. Some categories may not be shown in the UI or
     * not yet implemented, thus association is not defined (or commented out).
     * @type {Map<CategoryType, FilterTypeOptions>}
     */
    FilterTypeOptions.CATEGORY = new Map([
        [category_type_1.CategoryType.STANDARD, [
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.AMONG, true),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.NOT_AMONG),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.SPECIFIED),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.UNSPECIFIED),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.TOP),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.CONTAINS),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.NOT_CONTAINS),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.BEGINS_WITH)
            ]],
        [category_type_1.CategoryType.ME_ASSETS, [
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.AMONG, true),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.NOT_AMONG),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.SPECIFIED),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.UNSPECIFIED)
            ]],
        [category_type_1.CategoryType.DOCUMENT, []],
        [category_type_1.CategoryType.DATE, [
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.AMONG),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.NOT_AMONG),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.SPECIFIED),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.UNSPECIFIED),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.CURRENT),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.NOT_CURRENT),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.PREVIOUS),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.NEXT),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.BETWEEN, true),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.NOT_BETWEEN),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.ON_OR_BEFORE),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.ON_OR_AFTER)
            ]],
        [category_type_1.CategoryType.CURRENCY, []],
        [category_type_1.CategoryType.USER, [
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.CURRENT_USER, true),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.AMONG),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.NOT_AMONG),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.SPECIFIED),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.UNSPECIFIED)
            ]],
    ]);
    /**
     * Knowledge-like mapping of timeline category and its subtypes to associated filtering methods. This is defined
     * separately from all other category types because timeline category has subtypes as well. Logic behind this is as
     * follows: if options for select subtype are explicitly defined then these are used, otherwise the options defined
     * for that category in general ({@link CategoryType.DATE}) are used.
     * @type {Map<DateCategoryType, FilterTypeOptions>}
     */
    FilterTypeOptions.CATEGORY_TIMELINE = new Map([
        [date_category_type_1.DateCategoryType.DAY, [
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.IS),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.IS_NOT),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.SPECIFIED),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.UNSPECIFIED),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.CURRENT),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.NOT_CURRENT),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.PREVIOUS),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.NEXT),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.BETWEEN, true),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.NOT_BETWEEN),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.ON_OR_BEFORE),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.ON_OR_AFTER),
            ]]
    ]);
    /**
     * Knowledge-like mapping of measure to associated filtering methods. Some measures may not be shown in the UI or
     * not yet implemented, thus association is not defined (or commented out).
     * @type {Map<MeasureType, FilterTypeOptions>}
     */
    FilterTypeOptions.MEASURE = new Map([
        [measure_type_1.MeasureType.NUMBER, [
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.EQUALS, true),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.NOT_EQUALS),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.BETWEEN),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.NOT_BETWEEN),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.LESS_THAN),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.LESS_THAN_OR_EQUALS),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.GREATER_THAN),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.GREATER_THAN_OR_EQUALS),
            ]],
        [measure_type_1.MeasureType.DATE, [
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.EQUALS),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.NOT_EQUALS),
                // new FilterTypeOption(FilterType.EMPTY),
                // new FilterTypeOption(FilterType.TODAY),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.BETWEEN, true),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.NOT_BETWEEN),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.ON_OR_BEFORE),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.ON_OR_AFTER),
            ]],
        [measure_type_1.MeasureType.TEXT, [
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.CONTAINS, true),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.NOT_CONTAINS),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.BEGINS_WITH),
            ]],
        [measure_type_1.MeasureType.MONEY, [
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.EQUALS, true),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.NOT_EQUALS),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.BETWEEN),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.NOT_BETWEEN),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.LESS_THAN),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.LESS_THAN_OR_EQUALS),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.GREATER_THAN),
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.GREATER_THAN_OR_EQUALS),
            ]],
        [measure_type_1.MeasureType.BOOLEAN, [
                new filter_type_option_1.FilterTypeOption(filter_type_1.FilterType.EQUALS, true),
            ]],
    ]);
    return FilterTypeOptions;
}(combobox_options_1.ComboboxOptions));
exports.FilterTypeOptions = FilterTypeOptions;
//# sourceMappingURL=filter-type-options.js.map